// extracted by mini-css-extract-plugin
module.exports = {"uploadDocWrapper":"uploadedByInfo_uploadDocWrapper__3nxeO","label":"uploadedByInfo_label__cYisK","value":"uploadedByInfo_value__2IOyj","date":"uploadedByInfo_date__NERo3"};